import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { fetchUserMappedFeatureData } from "../../../redux/dashboard-features/featuresSlice";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { getColorForMenuId } from "../features";
import CmnFilters from "../../lead-management/common/CmnFilters";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";
import { delete_feature_map } from "../../../data/ApiEndpoints";
import { showConfirmAlert } from "../../components-react/ReactAlert";

const FeatureMappedWithUser = ({ userInfoData, rowData, callFunction }) => {
  const dispatch = useDispatch();
  const {
    userMappedFeatures,
    userMappedFeaturesLoading,
    userMappedFeaturesError,
  } = useSelector((state) => state.features);

  const iniAllFilter = {
    selectedMenu: "",
    selectedFeature: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    user_id: rowData?.user_id || "",
    menu_id: allFilters.selectedMenu?.value || "",
    feature_id: allFilters.selectedFeature?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getAllMappedFeatures(filters) {
    dispatch(
      fetchUserMappedFeatureData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: delete_feature_map,
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            callFunction();
            getAllMappedFeatures(filters);
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete!`);
    } else {
      toast.error("UID required!");
    }
  };

  useEffect(() => {
    if (filters.user_id) {
      getAllMappedFeatures(filters);
    }
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      menu_id: allFilters.selectedMenu?.value || "",
      feature_id: allFilters.selectedFeature?.value || "",
    }));
  }, [allFilters.selectedMenu, allFilters.selectedFeature]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
    }
  }, [allFilters.searchString]);

  useEffect(() => {
    if (
      userMappedFeatures?.status &&
      userMappedFeatures?.data?.length > 0 &&
      !userMappedFeaturesLoading &&
      !userMappedFeaturesError
    ) {
      const transformedData = userMappedFeatures.data.flatMap((item) =>
        item.sub_menu.map((sub) => ({
          ...sub,
          menu_id: item.menu_id,
          menu_name: item.label,
        }))
      );

      setAllDatas((prevs) => ({
        ...prevs,
        allData: transformedData,
        pagination:
          userMappedFeatures?.pagination?.length > 0
            ? userMappedFeatures.pagination
            : [],
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [userMappedFeatures, userMappedFeaturesLoading, userMappedFeaturesError]);

  const tbColumns = [
    {
      dataField: "menu_id",
      text: "menu name",
      formatter: (cell, row) => {
        const color = getColorForMenuId(row?.menu_id);

        return (
          <span
            className="tb-data"
            style={{
              background: color,
              color: "#fff",
              padding: "5px 10px",
              borderRadius: "4px",
            }}
          >
            {row?.menu_name || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "label",
      text: "page name",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.label || "NA"}</span>;
      },
    },
    {
      dataField: "path",
      text: "path",
      formatter: (cell, row) => {
        return <span className="tb-data lowercase">{row?.path || "NA"}</span>;
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon delete"
            onClick={(e) => {
              const filters = {
                uid: row?.uid || "",
              };
              handleDelete(filters);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                d="M8.49846 4.3041H11.4978C11.4978 3.90637 11.3398 3.52492 11.0585 3.24369C10.7773 2.96245 10.3958 2.80445 9.99811 2.80445C9.60038 2.80445 9.21893 2.96245 8.9377 3.24369C8.65646 3.52492 8.49846 3.90637 8.49846 4.3041ZM7.4987 4.3041C7.4987 3.64121 7.76203 3.00548 8.23076 2.53675C8.69949 2.06802 9.33522 1.80469 9.99811 1.80469C10.661 1.80469 11.2967 2.06802 11.7655 2.53675C12.2342 3.00548 12.4975 3.64121 12.4975 4.3041H17.4963C17.6289 4.3041 17.7561 4.35676 17.8498 4.45051C17.9435 4.54425 17.9962 4.6714 17.9962 4.80398C17.9962 4.93655 17.9435 5.0637 17.8498 5.15745C17.7561 5.25119 17.6289 5.30386 17.4963 5.30386H16.4426L15.2489 15.6454C15.1645 16.3764 14.8143 17.0509 14.265 17.5405C13.7156 18.0302 13.0054 18.3007 12.2696 18.3008H7.72664C6.99077 18.3007 6.2806 18.0302 5.73125 17.5405C5.18191 17.0509 4.83173 16.3764 4.74735 15.6454L3.55363 5.30386H2.49988C2.3673 5.30386 2.24016 5.25119 2.14641 5.15745C2.05267 5.0637 2 4.93655 2 4.80398C2 4.6714 2.05267 4.54425 2.14641 4.45051C2.24016 4.35676 2.3673 4.3041 2.49988 4.3041H7.4987ZM8.99834 8.30315C8.99834 8.17057 8.94568 8.04343 8.85193 7.94968C8.75819 7.85593 8.63104 7.80327 8.49846 7.80327C8.36588 7.80327 8.23874 7.85593 8.14499 7.94968C8.05125 8.04343 7.99858 8.17057 7.99858 8.30315V14.3017C7.99858 14.4343 8.05125 14.5615 8.14499 14.6552C8.23874 14.7489 8.36588 14.8016 8.49846 14.8016C8.63104 14.8016 8.75819 14.7489 8.85193 14.6552C8.94568 14.5615 8.99834 14.4343 8.99834 14.3017V8.30315ZM11.4978 7.80327C11.3652 7.80327 11.238 7.85593 11.1443 7.94968C11.0505 8.04343 10.9979 8.17057 10.9979 8.30315V14.3017C10.9979 14.4343 11.0505 14.5615 11.1443 14.6552C11.238 14.7489 11.3652 14.8016 11.4978 14.8016C11.6303 14.8016 11.7575 14.7489 11.8512 14.6552C11.945 14.5615 11.9976 14.4343 11.9976 14.3017V8.30315C11.9976 8.17057 11.945 8.04343 11.8512 7.94968C11.7575 7.85593 11.6303 7.80327 11.4978 7.80327Z"
                fill="black"
              />
            </svg>
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      <CmnFilters
        from={"assigned-feature"}
        userInfoData={userInfoData}
        onClickReset={onResetFilters}
        filters={allFilters}
        setFilters={setAllFilters}
        onClickSearch={onClickSearch}
        searchFilterApplied={searchFilterApplied}
        isLoading={userMappedFeaturesLoading}
      />

      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
        {userMappedFeaturesLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allDatas.allData}
            tableColumns={tbColumns}
          />
        )}
      </div>
    </>
  );
};

export default FeatureMappedWithUser;
